import clsx from 'clsx';
import { memo, type FC } from 'react';

type Props = {
    continueButtonVisible: boolean;
};

// This element is a portal target placed in the frame player footer so frames can place components in the footer
const LessonFooterPortalAnchorComponent: FC<Props> = ({ continueButtonVisible }) => {
    // On xs screens, the portal content animates up above the continue button when it is showing
    const xsTranslateClass = continueButtonVisible ? 'translate-y-[-50px]' : 'translate-y-0';

    // The [data-lesson-footer-portal] is positioned absolutely relative to wrappers above here in show_frames_player.html. For
    // that reason, we do not want to position the top-level element here
    return (
        <div className="lesson-footer-portal-anchor pointer-events-none absolute left-0 top-0 h-full w-full">
            <div
                data-lesson-footer-portal
                className={clsx(
                    'pointer-events-auto absolute bottom-[10px] left-[10px] right-[10px] z-[500] transform transition-all duration-300 ease-in-out',
                    'sm:bottom-[10px] sm:left-0 sm:right-0 sm:translate-y-0',
                    xsTranslateClass,
                )}
            />
        </div>
    );
};

export const LessonFooterPortalAnchor = memo(
    LessonFooterPortalAnchorComponent,
) as typeof LessonFooterPortalAnchorComponent;
